import { PageLoaderService } from './../../ui-components/page-loader';
import { Component, Input, Output, OnInit, EventEmitter, ElementRef, ViewEncapsulation } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilityService, AdobeAnalyticsService } from './../../../src/providers';
import { KEY_CONFIG } from './../../../src/config/key-config';

declare var ENV_VAR: any;

@Component({
    selector : 'app-gvp-video',
    templateUrl : './gvp-video.component.html',
    styleUrls : ['./gvp-video.component.scss'],
    providers: [ AdobeAnalyticsService],
    encapsulation: ViewEncapsulation.None
})

export class GvpVideoComponent implements OnInit {
    public focusAbleElements: any;
    @Input() videoId: any;
    @Input() triggerElement: any;
    @Output() modalOutput: EventEmitter<boolean>;

    constructor(private util: UtilityService, private el: ElementRef,
      private adobeAnalyticsService: AdobeAnalyticsService,
      private router: Router, private pageloaderService: PageLoaderService) {
        this.modalOutput = new EventEmitter<boolean>();  
    }

    ngOnInit() {
  
        }

    loadFocustelements() {
        if (!this.focusAbleElements) {
          const focusAbleEls = this.util.getFocusableElements(this.el);
          this.focusAbleElements = Array.prototype.slice.call(focusAbleEls);      
          document.getElementById('modalVideo').focus();          
        }
      }

      handleKeydown(event) {
        if (event.keyCode === KEY_CONFIG.escapeKey) {
          this.dimissModal(false);
          return;
        } 
        this.util.handleKeyPress(event, this.focusAbleElements);
      }
      dimissModal(value, event?) {
        if (!event || event.keyCode === KEY_CONFIG.enter || event.keyCode === KEY_CONFIG.space) {
          if (event) {
            event.preventDefault();
            event.stopPropagation();
          }
          this.modalOutput.emit(value);
          this.focusAbleElements = undefined;
          if (this.triggerElement) {
            this.triggerElement.focus();
          }
        }
      }
    cancelModal(value) {
      this.modalOutput.emit(value);
       if (this.triggerElement) {
         this.triggerElement.focus();
       }
    }

    adobeLinkClick() {
      this.adobeAnalyticsService.createClickProperties('Overview tutorial', 'Body', '/businessconsole/learn');
    }

    handleError(error) {
    this.pageloaderService.setPageLoaderStatus(true);
    throw error;
  }
}
